import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IAppContextValue } from './types';

export default createContext<IAppContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
